import React from 'react';
import ReactDOM from 'react-dom';
import '../galleries/carousel/index2';
import '../videos';
import '../menus/collapse/index';
import '../menus/read-more/index';
import '../menus/drop-down/index'; // pure javascript drop-down
import '../../domain/gaevent/index'; // send ga-event
import { getJSONFromHtml, isMobile } from '../../domain/common';
import { sendGAPageTypeEvent, sendGAWavesUserGuidEvent } from '../../domain/marketing/gtm-provider';
import { initUTMs } from '../../domain/marketing/utm/utm-provider';
import { ICommonGallery } from '../common-product-gallery/interfaces';
import { Provider } from 'react-redux';
import commonProductGalleryStore from '../common-product-gallery/data-services/store';
import recentlyViewedProductsStore from '../recently-viewed-products/data/store';
import CommonProductGallery from '../common-product-gallery/common-product-gallery';
import { sendInitialAnalytics } from '../common-product-gallery/data-services/data-service';
import { IListItem } from '../list-page/interfaces/interfaces';
import RecentlyViewedProducts from '../recently-viewed-products/rvp-gallery/rvp-gallery';
import GDPR from '../gdpr/gdpr';
import { renderYoutubeVideos } from '../../domain/videos/videos-provider';
import { initOldWebsiteCompatibility } from '../../domain/old-website/old-website-compat';
import { deferScript } from '../../domain/defer-script';
import TimerCountDown from "../../ui/clock/count-down-timer/count-down-timer";
import { sendFacebookPageViewEvent } from '../../domain/facebook/facebook-marketing-provider';
import { initAddToCartPopup } from '../add-to-cart-popup';
import { initPersonalization } from '../personalization';
import { initIntercom } from '../../domain/marketing/intercom';
import { initMyOffers } from '../my-offers/my-offers-provider';
import { initFooterGDPR } from '../gdpr/gdpr-footer';
import { getABTest, sendABTestAnalytics } from '../../domain/abtest/abtest-provider';

/**
 * general product grids, like 'included in' etc.
 */
const handleCommonProductGallery = () => {

    const $galleries = document.querySelectorAll('.react-common-product-list');
    $galleries.forEach($gallery => {

        // get gallery properties
        const dataID = $gallery.getAttribute('data-id');
        const dataType = $gallery.getAttribute('data-type');
        const dataPageType = $gallery.getAttribute('data-page-type');
        const dataTab = $gallery.getAttribute('data-tab');
        const listName = $gallery.getAttribute('data-list-name');
        const useBuiltInTitle = $gallery.getAttribute('data-use-built-in-title');
        const dataCustomTitle = $gallery.getAttribute('data-custom-title-text');
        const dataCustomTitleCss = $gallery.getAttribute('data-custom-title-css');
        const dataCustomSubTitle = $gallery.getAttribute('data-custom-sub-title-text');
        const isButtonAndNoteHidden = $gallery.getAttribute('data-hide-button-note');
        const isPriceFirstRowHidden = $gallery.getAttribute('data-hide-first-row');
        const isPriceSecondRowHidden = $gallery.getAttribute('data-hide-second-row');
        const isPriceThirdRowHidden = $gallery.getAttribute('data-hide-third-row');
        const isFirstMerchRowHidden = $gallery.getAttribute('data-hide-first-merch-row');
        const isPriceDiscountBadgeHidden = $gallery.getAttribute('data-hide-discount-badge');
        const isExpectedShippingHidden = $gallery.getAttribute('data-hide-expected-shipping');
        const isTaglineHidden = $gallery.getAttribute('data-hide-tagline');
        const isClockHidden = $gallery.getAttribute('data-hide-clock');
        const numberOfRowsShown = $gallery.getAttribute('data-rows-shown');
        const showMoreLess = $gallery.getAttribute('data-more-less');
        const isDataExplore = $gallery.getAttribute('data-explore');
        const isRemoveImgLink = $gallery.getAttribute('data-remove-img-link');
        const isRemoveTitleLink = $gallery.getAttribute('data-remove-title-link');
        const useSrcDetails = $gallery.getAttribute('data-use-src-details');
        const priceCustomText = $gallery.getAttribute('data-price-custom-text');
        const desctopSize = $gallery.getAttribute('data-desctop-size');
        const tabletSize = $gallery.getAttribute('data-tablet-size');
        const mobileSize = $gallery.getAttribute('data-mobile-sizes');
        const gridGap = $gallery.getAttribute('data-grid-gap');
        const staticClass = $gallery.getAttribute('data-static-class');
        const imageHeight = $gallery.getAttribute('data-image-height');

        const commonGalleryProps = {
            listName: listName,
            isTaglineHidden:isTaglineHidden && isTaglineHidden === 'true',
            useBuiltInTitle:useBuiltInTitle && useBuiltInTitle === 'true',
            isButtonAndNoteHidden: isButtonAndNoteHidden && isButtonAndNoteHidden === 'true',
            isPriceFirstRowHidden: isPriceFirstRowHidden && isPriceFirstRowHidden === 'true',
            isPriceSecondRowHidden: isPriceSecondRowHidden && isPriceSecondRowHidden === 'true',
            isPriceThirdRowHidden: isPriceThirdRowHidden && isPriceThirdRowHidden === 'true',
            isFirstMerchRowHidden: isFirstMerchRowHidden && isFirstMerchRowHidden === 'true',
            isPriceDiscountBadgeHidden: isPriceDiscountBadgeHidden && isPriceDiscountBadgeHidden === 'true',
            isExpectedShippingHidden: isExpectedShippingHidden && isExpectedShippingHidden === 'true',
            isClockHidden: isClockHidden && isClockHidden === 'true',
            isRemoveImgLink: isRemoveImgLink && isRemoveImgLink === 'true',
            isRemoveTitleLink: isRemoveTitleLink && isRemoveTitleLink === 'true',
            useSrcDetails: useSrcDetails && useSrcDetails === 'true',
            priceCustomText: priceCustomText,
            showMoreLess: showMoreLess,
            numberOfRowsShown: (numberOfRowsShown === null || numberOfRowsShown === '' ? 9999 :  numberOfRowsShown),
            desctopSize: (desctopSize === null || desctopSize === '' ? 5 :  parseInt(desctopSize) ),
            tabletSize: (tabletSize === null || tabletSize === '' ? 3 :  parseInt(tabletSize)),
            mobileSize: (mobileSize === null || mobileSize === '' ? 2 :  parseInt(mobileSize)),
            gridGap: (gridGap === null || gridGap === '' ? 'gap-12' :  gridGap),
            staticClass: (staticClass === null || staticClass === '' ? null :  staticClass),
            isDataExplore: isDataExplore,
            dataID: dataID,
            dataType: dataType,
            dataPageType: dataPageType,
            dataTab: dataTab,
            dataCustomTitle: dataCustomTitle,
            dataCustomTitleCss: dataCustomTitleCss,
            dataCustomSubTitle: dataCustomSubTitle,
            imageHeight:imageHeight
        } as ICommonGallery;

        // get data root
        const $root = document.querySelector( `[data-id="${dataID}"]`);
        if(!$root) return;

        const productGallery = getJSONFromHtml(document.getElementById(commonGalleryProps.dataID))  as IListItem[];
        // send product impression to GA
        sendInitialAnalytics(productGallery, commonGalleryProps.listName);

        ReactDOM.render(
            <React.StrictMode>
                <Provider store={commonProductGalleryStore}>
                    <CommonProductGallery productGallery={productGallery} commonGalleryProps={commonGalleryProps} />
                </Provider>
            </React.StrictMode>,
            $gallery
        );
    });

};

//https://wavesaudio.atlassian.net/browse/DSWEB-3116
//General time counter.
//<span data-counter-type="general" data-sale-end-date="2023/04/24 11:00:00"></span>
const handleCountDownTimers = () => {
    const $countDownTimers = document.querySelectorAll("[data-counter-type]");

    if (!$countDownTimers) return;

    $countDownTimers.forEach($countDownTimer  => {

        if(!$countDownTimer) return;

        /*Attributed start*/
        const dataSaleEndDate = $countDownTimer.getAttribute("data-sale-end-date") ?? '';
        const dataType = $countDownTimer.getAttribute("data-counter-type") ?? 'general';
        const dataClass = $countDownTimer.getAttribute("data-class");
        const dataClassEx = $countDownTimer.getAttribute("data-class-ex");
        let countDownTime;

        try{
            countDownTime= new Date(dataSaleEndDate);
            //Eastern Standard Time (EST). UTC -5. now 1 hour behind New York
            //countDownTime.setHours(countDownTime.getHours() - 1);
        }
        catch(ex){
            console.log('try parse countDownTime(' + dataSaleEndDate + '): ',ex);
        }
        if(!countDownTime)
            return;

        ReactDOM.render(
            <React.StrictMode>
                <TimerCountDown
                    expiredWhenNumber={countDownTime.getTime()}
                    timerType={dataType}
                    dataClass={dataClass ?? undefined}
                    dataClassEx={dataClassEx ?? undefined}
                />
            </React.StrictMode>,
            $countDownTimer
        );
    });

}

/**
 * handle recently viewed products
 * https://wavesaudio.atlassian.net/browse/DSWEB-1834
 */
const handleRecentlyViewedProducts = () => {

    const $root = document.getElementById('recently-viewed-products');
    if(!$root) return;

    const excludeMeta = document.querySelector('meta[name="exclude-rvp"][content="true"]');

    if(!excludeMeta){
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={ recentlyViewedProductsStore }>
                    <RecentlyViewedProducts/>
                </Provider>
            </React.StrictMode>,
            $root
        );
    }
};

const handleGdpr = () => {

    // https://wavesaudio.atlassian.net/browse/DSWEB-4440
    initFooterGDPR();

    const $root = document.getElementById('gdpr-widget');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <GDPR/>
        </React.StrictMode>,
        $root
    );
}

declare global {
    interface Window {
        _GUARANTEE: any;
    }
}

const nortonBadgeABTest = () => {

    if(isMobile()) return;

    const abtest = getABTest('NortonBadge');
    if(!abtest?.isActive) return;

    const found = document.getElementById('norton-badge-ab');
    if(!found) return;

    sendABTestAnalytics(abtest);

    if(abtest.selected === 'show') {
        window.waves.deferScript('//guarantee-cdn.com/Web/Seal/gjs.aspx?SN=950311404', function(){ });
    }

    /*
    window.waves.deferScript('//nsg.symantec.com/Web/Seal/gjs.aspx?SN=950311404', function(){
        if(window._GUARANTEE && _GUARANTEE.Loaded) {
            _GUARANTEE.Hash = 'fLVQ2Vvcs25wgQbb8EBWckemHW4McszULAldzyTE%2B0LZpV7WWeCbagcNEJIkX%2BhHs5GiU%2Fh9LQY2uer4uVsmcw%3D%3D';
            _GUARANTEE.WriteSeal("_GUARANTEE_SealSpan", "GuaranteedSeal");
        }
    });

    OR

    window.waves.deferScript('//guarantee-cdn.com/Web/Seal/gjs.aspx?SN=950311404', function(){ });
    */
};

/**
 * entry point
 */
const init = () => {

    // https://wavesaudio.atlassian.net/browse/DSWEB-3692
    initAddToCartPopup();

    // https://wavesaudio.atlassian.net/browse/DSWEB-1834
    handleRecentlyViewedProducts();

    // https://wavesaudio.atlassian.net/browse/DSWEB-1833
    handleGdpr();

    // https://wavesaudio.atlassian.net/browse/DSWEB-2203
    renderYoutubeVideos();

    /**
     * https://github.com/calibreapp/react-live-chat-loader/tree/main
     * https://developer.chrome.com/docs/lighthouse/performance/third-party-facades/?utm_source=lighthouse&utm_medium=devtools
     * https://wavesaudio.atlassian.net/browse/DSWEB-4416
     */
    initIntercom();

    // https://wavesaudio.atlassian.net/browse/DSWEB-1838
    initUTMs();

    /**
     * https://wavesaudio.atlassian.net/browse/DSWEB-1966
     * some banners depends on query string
     * these banners are handled via ajax
     */
    // initAjaxBanners();

    // send GA user guid event from the following hidden field:
    // <div id="ga-user-guid">@ViewBag.LayoutModel.GA_GUID</div>
    sendGAWavesUserGuidEvent();

    // https://wavesaudio.atlassian.net/browse/DSWEB-1188
    handleCommonProductGallery();

    // This collapsible version is used for converter tool to easily transform the collapsible
    // from old website to the new website.
    //initCollapsible();

    // old website compatibility
    initOldWebsiteCompatibility();

    // https://wavesaudio.atlassian.net/browse/DSWEB-632
    // handleNonBounceEvent();

    // https://wavesaudio.atlassian.net/browse/DSWEB-3116
    handleCountDownTimers();

    // New: https://wavesaudio.atlassian.net/browse/DSWEB-4709
    // Old: https://wavesaudio.atlassian.net/browse/DSWEB-4243
    initPersonalization();

    /**
     * https://wavesaudio.atlassian.net/browse/DSWEB-1059
     * https://wavesaudio.atlassian.net/browse/DSWEB-1966
     */
    initMyOffers();

    // send page type event to google analytics according to the following meta on the page:
    // <meta property="google-ecomm-pagetype" content="category">
    sendGAPageTypeEvent();

    // https://wavesaudio.atlassian.net/browse/DSWEB-4590
    const abtest = getABTest('GeneralAATest');
    if(abtest?.isActive) {
        sendABTestAnalytics(abtest);
    }

    // https://wavesaudio.atlassian.net/browse/DSWEB-4670
    nortonBadgeABTest();
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

window.addEventListener('load', () => {
    sendFacebookPageViewEvent();
});

// init external API
window.waves = window.waves || {};
window.waves.deferScript = deferScript;
